function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.5 0C19.404 0 25 5.596 25 12.5c0 2.787-.912 5.36-2.454 7.44l6.515 5.51a2.56 2.56 0 11-3.61 3.61l-5.511-6.514A12.444 12.444 0 0112.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0zm0 3a9.5 9.5 0 100 19 9.5 9.5 0 000-19zm0 13a1.5 1.5 0 11-1.493 1.644L11 17.5a1.5 1.5 0 011.5-1.5zm-.2-10c2.21 0 4 1.484 4 3.316 0 2.938-2.687 2.925-2.866 4.99l-.01.22a.487.487 0 01-.5.474H11.8a.494.494 0 01-.492-.389l-.008-.085c0-3.147 2.812-2.85 2.812-5.21 0-.785-.94-1.421-1.906-1.421-.915 0-1.82.57-1.914 1.298l-.008.123a2.34 2.34 0 00.072.6l.058.194a.466.466 0 01-.305.6.523.523 0 01-.165.027H8.93a.505.505 0 01-.456-.273l-.029-.074c-.1-.35-.148-.712-.144-1.074C8.3 7.485 10.091 6 12.3 6z",
  fill: "#E1E9F0",
  fillRule: "evenodd"
});

var SvgEmptySearch = function SvgEmptySearch(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref);
};

export default SvgEmptySearch;